/* DO NOT EDIT THIS FILE DIRECTLY
 * This file is generated from a template
 * https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/1961002737/Business+Concept+Change+Process
 */
export enum TEAMS {
  booking_confidence = 'booking_confidence',
  booking_experience = 'booking_experience',
  client_platform = 'client_platform',
  cloud_infrastructure = 'cloud_infrastructure',
  provider_tooling = 'provider_tooling',
  data_platform = 'data_platform',
  grooming = 'grooming',
  discovery = 'discovery',
  recommendations = 'recommendations',
  no_owner = 'no_owner',
  trust_safety_engineering = 'trust_safety_engineering',
  orders = 'orders',
  payments = 'payments',
  search_experience = 'search_experience',
  backend_platform = 'backend_platform',
  training = 'training',
  partnerships_integrations = 'partnerships_integrations',
  developer_experience = 'developer_experience',
  booking_success = 'booking_success',
  owner_retention = 'owner_retention',
  inbox_and_chat = 'inbox_and_chat',
  martech = 'martech',
  provider_loyalty = 'provider_loyalty',
  provider_nurturing = 'provider_nurturing',
  price_experience = 'price_experience',
}

export type Concept = readonly [string, TEAMS];

export const CONCEPTS = {
  bookings: {
    creation: ['Bookings: Creation', TEAMS.booking_experience],
    credits: ['Bookings: Credits', TEAMS.booking_success],
    edit: ['Bookings: Edit', TEAMS.booking_confidence],
    cancellation: ['Bookings: Cancellation', TEAMS.booking_confidence],
    dates: ['Bookings: Dates', TEAMS.booking_experience],
    defunct: ['Bookings: Defunct', TEAMS.booking_experience],
    meet_and_greet: ['Bookings: Meet & Greet', TEAMS.owner_retention],
    notifications: ['Bookings: Notifications', TEAMS.owner_retention],
    repeat: ['Bookings: Rebooking', TEAMS.owner_retention],
    recurring: ['Bookings: Recurring', TEAMS.provider_tooling],
    reviews: ['Bookings: Reviews', TEAMS.trust_safety_engineering],
    tipping: ['Bookings: Tipping', TEAMS.provider_loyalty],
    pricing: ['Bookings: Pricing', TEAMS.price_experience],
    assignment: ['Bookings: Assignment', TEAMS.provider_tooling],
    inbox: ['Bookings: Inbox', TEAMS.inbox_and_chat],
    grooming: ['Bookings: Grooming', TEAMS.grooming],
    service_delivery: ['Bookings: Service Delivery', TEAMS.provider_tooling],
    anti_diversion: ['Bookings: Anti-Diversion', TEAMS.booking_success],
    trust_and_safety: ['Bookings: Trust and Safety', TEAMS.trust_safety_engineering],
    external_platform: ['Bookings: External Platform', TEAMS.grooming],
  },
  communications: {
    thread: ['Communications: Thread', TEAMS.inbox_and_chat],
    support: ['Communications: Support', TEAMS.booking_confidence],
    notification_channels: ['Communications: Notification Channels', TEAMS.martech],
    phones: ['Communications: Phones', TEAMS.martech],
    ugc: ['Communications: UGC', TEAMS.inbox_and_chat],
    video_calls: ['Communications: Video Calls', TEAMS.inbox_and_chat],
    trust_and_safety: ['Communications: Trust and Safety', TEAMS.trust_safety_engineering],
    crm: ['Communications: CRM', TEAMS.martech],
    deeplinking: ['Communications: Deeplinking', TEAMS.martech],
    notifications_management: ['Communications: Notifications Management', TEAMS.martech],
  },
  finance: {
    general_ledger: ['Finance: General Ledger', TEAMS.orders],
    month_close: ['Finance: Month Close', TEAMS.orders],
    subledger: ['Finance: Subledger', TEAMS.orders],
  },
  marketing: {
    growth: ['Marketing: Growth', TEAMS.discovery],
    m_and_a: ['Marketing: M&A', TEAMS.partnerships_integrations],
    supply: ['Marketing: Supply', TEAMS.provider_nurturing],
    referrals: ['Marketing: Referrals', TEAMS.discovery],
    promos: ['Marketing: Promos', TEAMS.payments],
    crm: ['Marketing: CRM', TEAMS.booking_experience],
    corporate: ['Marketing: Corporate', TEAMS.discovery],
    craigslist: ['Marketing: Craigslist', TEAMS.discovery],
  },
  orders: {
    order_and_line_items: ['Orders: Order & Line Items', TEAMS.orders],
    sales_tax: ['Orders: Sales Tax', TEAMS.orders],
    vat: ['Orders: VAT', TEAMS.orders],
    database: ['Orders: Database', TEAMS.orders],
  },
  payments: {
    donations: ['Payments: Donations', TEAMS.payments],
    know_your_customer: ['Payments: Know Your Customer', TEAMS.payments],
    payins: ['Payments: Payins', TEAMS.payments],
    payouts: ['Payments: Payouts', TEAMS.payments],
  },
  people_and_pets: {
    authentication: ['People & Pets: Authentication', TEAMS.booking_confidence],
    compliance: ['People & Pets: Compliance', TEAMS.martech],
    preferences: ['People & Pets: Preferences', TEAMS.martech],
    profile: ['People & Pets: Profile', TEAMS.trust_safety_engineering],
    trust_and_safety: ['People & Pets: Trust and Safety', TEAMS.trust_safety_engineering],
    external_platform_profile: ['People & Pets: External Platform Profile', TEAMS.grooming],
  },
  platform: {
    api: ['Platform: API', TEAMS.client_platform],
    mobile: ['Platform: Mobile', TEAMS.client_platform],
    accessibility: ['Platform: Accessibility', TEAMS.client_platform],
    design_systems: ['Platform: Design Systems', TEAMS.client_platform],
    reactjs_server_side_rendering: [
      'Platform: React.js Server Side Rendering',
      TEAMS.client_platform,
    ],
    web_client: ['Platform: Web Client', TEAMS.client_platform],
    deeplinks: ['Platform: Deeplinks', TEAMS.client_platform],
    development: ['Platform: Development', TEAMS.developer_experience],
    international: ['Platform: International', TEAMS.discovery],
    eventstream: ['Platform: Eventstream', TEAMS.data_platform],
    analytics: ['Platform: Analytics', TEAMS.recommendations],
    experiments: ['Platform: Experiments', TEAMS.recommendations],
    geospatial: ['Platform: Geospatial', TEAMS.recommendations],
    admin: ['Platform: Admin', TEAMS.booking_confidence],
    redirects: ['Platform: Redirects', TEAMS.backend_platform],
    async_tasks: ['Platform: Async Tasks', TEAMS.backend_platform],
    sre: ['Platform: SRE', TEAMS.backend_platform],
    cron: ['Platform: Cron', TEAMS.backend_platform],
    wordpress: ['Platform: WordPress', TEAMS.discovery],
  },
  recommendations: {
    alternatives: ['Recommendations: Alternatives', TEAMS.booking_experience],
    assignment: ['Recommendations: Assignment', TEAMS.recommendations],
    browse_search: ['Recommendations: Browse Search', TEAMS.recommendations],
    contactability: ['Recommendations: Contactability', TEAMS.recommendations],
    marketplace_management: ['Recommendations: Marketplace Management', TEAMS.recommendations],
    repeat: ['Recommendations: Repeat', TEAMS.recommendations],
    insights: ['Recommendations: Provider Insights', TEAMS.provider_tooling],
    platform: ['Recommendations: Platform', TEAMS.recommendations],
    price_transparency: ['Recommendations: Price Transparency', TEAMS.price_experience],
    provider_profile: ['Recommendations: Provider Profile', TEAMS.recommendations],
    training: ['Recommendations: Dog Training Search', TEAMS.training],
    job_board: ['Recommendations: Job Board', TEAMS.booking_experience],
  },
  service_offerings: {
    pricing: ['Service Offerings: Pricing', TEAMS.price_experience],
    overnight_traveling: ['Service Offerings: Overnight Traveling', TEAMS.provider_tooling],
    assignment: ['Service Offerings: Assignment', TEAMS.provider_tooling],
    grooming: ['Service Offerings: Grooming', TEAMS.grooming],
    training: ['Service Offerings: Training', TEAMS.training],
    insurance: ['Service Offerings: Insurance', TEAMS.partnerships_integrations],
    availability: ['Service Offerings: Availability', TEAMS.provider_tooling],
    provider_profile: ['Service Offerings: Provider Profile', TEAMS.provider_nurturing],
    walking: ['Service Offerings: Walking', TEAMS.provider_tooling],
    background_checks: ['Service Offerings: Background Checks', TEAMS.trust_safety_engineering],
    rover_guarantee: ['Service Offerings: Rover Guarantee', TEAMS.provider_loyalty],
    graduated_take_rate: ['Service Offerings: Graduated Take Rate', TEAMS.provider_loyalty],
  },
  star_sitter: {
    star_sitter: ['Star Sitter: Star Sitter', TEAMS.provider_loyalty],
    star_provider: ['Star Sitter: Star Provider', TEAMS.provider_loyalty],
  },
} as const;
